module.exports = __webpack_public_path__ + "img/04_uk.76576c73.svg";